// generated by genversion
export var version = '3.2.5';
//# sourceMappingURL=version.js.map